





























































































































































import moment from 'moment';
import IphoneXFrame from '@/components/IphoneXFrame/IphoneXFrame.vue';
import SectionContainer from '@/components/SectionContainer/SectionContainer.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { toNumber } from '@/utils/moneyTreatments';
@Component({
  components: {
    IphoneXFrame,
    SectionContainer
  }
})
export default class MobileOfferDetailsPreview extends Vue {
  business = this.$store.getters['business/getBusinessInfo'].business;

  getFormatedDiscount(
    typeDiscount: string,
    value: string,
    isDiscount?: boolean
  ) {
    if (value === 'Free') return value;
    else if (!value) return 'Price Here';

    if (typeDiscount === 'percent_discount') {
      return `${value}%`;
    }
    return `$${value} ${isDiscount ? 'OFF' : ''}`;
  }

  calcDiscount(
    typeDiscount: string,
    valueOfferStr: string,
    valueDiscountStr: string
  ) {
    let res: number;
    const valueOffer: number = toNumber(valueOfferStr);
    const valueDiscount: number = toNumber(valueDiscountStr);

    if (typeDiscount === 'percent_discount') {
      res = valueOffer - (valueOffer * valueDiscount) / 100;
    } else {
      res = valueOffer - valueDiscount;
    }

    return res > 0 ? res.toFixed(2) : 'Free';
  }

  get rules() {
    const rules = this.getOfferPreview.OfferPreview.rulesOffer;
    if (!rules) return [];
    const finePrintDescription = [];
    for (let i = 0; i < rules.length; i += 1) {
      const rule = rules[i];
      const {
        ruleRedeemedItems,
        rulePerCustomer
      } = this.getOfferPreview.OfferPreview;

      switch (rule) {
        case 'cannot_combine_offers':
          finePrintDescription.push(
            'This offer cannot be combined with other offers.'
          );
          break;

        case 'max_redeemed_items':
          if (this.hasMaxRedemeed) {
            finePrintDescription.push(
              `There ${
                +ruleRedeemedItems > 1 ? 'are' : 'is'
              } ${ruleRedeemedItems} coupon${
                +ruleRedeemedItems > 1 ? 's' : ''
              } available for this offer.`
            );
          }
          break;

        case 'max_redeemed_items_per_customers':
          finePrintDescription.push(
            `There ${
              +rulePerCustomer > 1 ? 'are' : 'is'
            } a limit of ${rulePerCustomer} coupon${
              +rulePerCustomer > 1 ? 's' : ''
            } per user.`
          );
          break;

        default:
          break;
      }
    }
    if (this.hasDateToExpirate) {
      finePrintDescription.push(
        `This offer will expire on ${this.expirationDate}.`
      );
    }
    if (this.isBirthday) {
      finePrintDescription.push(
        'Valid 3 days before and until 3 days after your birthday. And please remember to bring/show your ID when redeeming.'
      );
    }

    return finePrintDescription;
  }

  get isBirthday(): boolean {
    return this.getOfferPreview.OfferPreview.isBirthday;
  }

  get hasDateToExpirate(): boolean {
    return (
      this.getOfferPreview.OfferPreview.hasDateToExpirate &&
      this.getOfferPreview.OfferPreview.dateToExpirate
    );
  }

  get hasMaxRedemeed(): boolean {
    return (
      this.getOfferPreview.OfferPreview.rulesOffer &&
      this.getOfferPreview.OfferPreview.rulesOffer.includes(
        'max_redeemed_items'
      ) &&
      this.getOfferPreview.OfferPreview.ruleRedeemedItems
    );
  }

  get expirationDate() {
    return moment
      .utc(this.getOfferPreview.OfferPreview.dateToExpirate)
      .locale('en')
      .format('MMM Do, YYYY');
  }

  get getOfferPreview(): any {
    return this.$store.getters['offer/getOfferInformation'];
  }

  get isTextDiscount(): boolean {
    return this.getOfferPreview.OfferPreview.typeDiscount === 'open_text_field';
  }

  get hasDiscount(): boolean {
    return (
      this.getOfferPreview.OfferPreview.valueDiscount !== '0' &&
      this.getOfferPreview.OfferPreview.valueDiscount
    );
  }

  get getPicture() {
    return this.business.logo.publicPath.small;
  }
}
